<template>
  <div class="vmp-chat-img-upload-container">
    <vh-upload
      list-type="text"
      v-if="![2, '2'].includes(roleName)"
      class="vmp-chat-img-upload"
      :headers="headersVo"
      :action="action"
      :show-file-list="false"
      name="resfile"
      :before-upload="beforeUpload"
      :data="{
        path: `${roomId}/img`,
        type: 'image',
        interact_token: interact_token
      }"
      accept=".jpg, .jpeg, .png, .bmp"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
      <i :class="['vh-iconfont', 'vh-line-picture-outline', uploadActive ? 'active' : '']"></i>
    </vh-upload>
    <!-- 上传图片预览 -->
    <div v-show="uploadActive" class="vmp-chat-img-preview-wrap">
      <div class="vmp-chat-img-preview" v-for="(url, index) in imgUrls" :key="index">
        <img width="100%" height="100%" v-lazy="url" />
        <i class="vmp-chat-img-preview-close" @click="deleteImg(index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { uuid } from '@/app-shared/utils/tool';
  import { useRoomBaseServer } from 'middle-domain';
  import { cl_toast } from '@/app-shared/client/client-methods.js';
  export default {
    name: 'VmpChatImgUpload',
    props: {
      //房间号
      roomId: {
        type: [Number, String],
        default: ''
      },
      //用户身份
      roleName: {
        type: [Number, String],
        default: ''
      },
      //是否被禁言
      disable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        //图片地址列表
        imgUrls: [],
        //上传图片请求的token
        headToken: localStorage.getItem('token') || '',
        interact_token: '',
        //上传图片地址
        action: `${process.env.VUE_APP_BASE_URL}/v3/commons/upload/index`
      };
    },
    computed: {
      headersVo() {
        const vo = {
          // 助理&嘉宾端不传token
          token: this.roleName == 3 || this.roleName == 4 ? '' : this.headToken,
          platform: 7,
          'gray-id': sessionStorage.getItem('initGrayId') || '',
          'request-id': uuid()
        };
        // 获取参数
        const wIdIndex0 = location.href.lastIndexOf('/');
        const wIdIndex1 = location.href.lastIndexOf('?');
        const wId = location.href.substring(
          wIdIndex0 + 1,
          wIdIndex1 > 0 ? wIdIndex1 : location.href.length
        );
        if (sessionStorage.getItem(`V3_WAP_US_${wId}`)) {
          vo['gray-id'] = sessionStorage.getItem(`V3_WAP_US_${wId}`);
        }
        console.log('vo:', vo);
        return vo;
      },
      //是否已有上传图片
      uploadActive() {
        return this.imgUrls.length;
      }
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
    },
    mounted() {
      this.initViewData();
    },
    methods: {
      //初始化视图数据
      initViewData() {
        const { state = {} } = this.roomBaseServer;
        this.interact_token = state.watchInitData.interact.interact_token || '';
      },
      //上传图片前置处理
      beforeUpload() {
        if (this.disable) {
          if (this.$route.query.assistantType) {
            cl_toast('error', this.$t('chat.chat_1006'));
          } else {
            this.$message.error(this.$t('chat.chat_1006'));
          }

          return false;
        }
        if (this.uploadActive >= 4) {
          if (this.$route.query.assistantType) {
            cl_toast('error', this.$t('host.k_511001'));
          } else {
            this.$message.error(this.$t('host.k_511001'));
          }

          return false;
        }
        return true;
      },
      //上传图片成功
      uploadSuccess(res) {
        if (!['200', 200].includes(res.code)) {
          if (this.$route.query.assistantType) {
            cl_toast('warning', res.msg);
            return;
          } else {
            return this.$message.warning(res.msg);
          }
        }
        this.imgUrls.push(res.data.domain_url);
      },
      //上传聊天图片失败
      uploadError(err) {
        console.error('======上传聊天图片失败======', err);
      },
      //删除图片
      deleteImg(index) {
        this.imgUrls.splice(index, 1);
      },
      //获取上传成功的图片
      getImgUrls() {
        return this.imgUrls;
      },
      //清空上传成功的图片
      clearImgUrls() {
        this.imgUrls = [];
      }
    }
  };
</script>

<style lang="less">
  .vmp-chat-img-upload-container {
    @active-color: #fb3a32;
    .vh-iconfont {
      color: #999;
      font-size: 19px;
      cursor: pointer;
      &.active {
        color: @active-color;
      }
      &:hover {
        color: @active-color;
        cursor: pointer;
      }
      &.vh-line-picture-outline {
        font-size: 18px;
      }
    }
    .vmp-chat-img-preview-wrap {
      padding: 8px;
      background: #3f3f3f;
      position: absolute;
      top: -60px;
      left: 5%;
      box-sizing: border-box;
      .vmp-chat-img-preview {
        float: left;
        width: 34px;
        height: 34px;
        margin-right: 8px;
        position: relative;
        box-sizing: border-box;
        cursor: pointer;
        &-close {
          position: absolute;
          width: 15px;
          height: 15px;
          background: url('../img/img-del.png') no-repeat;
          background-size: contain;
          top: 0;
          right: 0;
          display: none;
        }
        & > img {
          display: block;
        }
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border: 1px solid @active-color;
          .vmp-chat-img-preview-close {
            display: block;
          }
        }
      }
    }
  }
</style>
